'use client';
import { DEFAULT_HEADING_SIZES, DEFAULT_HEADING_HEIGHTS, DEFAULT_TEXT_SIZES, DEFAULT_TEXT_HEIGHTS } from '../Typography/Typography.contract.js';

var COMPONENT_ID = "Skeleton";
var defaultProps = {
    color: "button.secondary",
    accentColor: "background.content",
    spacing: 0,
    align: "center",
    textAlign: "center",
    visible: true,
    animate: true,
    animation: "wave",
    typography: {
        heading: {
            sizes: DEFAULT_HEADING_SIZES,
            heights: DEFAULT_HEADING_HEIGHTS
        },
        text: {
            sizes: DEFAULT_TEXT_SIZES,
            heights: DEFAULT_TEXT_HEIGHTS
        }
    }
};

export { COMPONENT_ID, defaultProps };
